import { t } from 'i18next';

export const LeaderboardHeader = () => {
  return (
    <div className="grid w-full grid-cols-[4%_30%_12%_12%_12%_10%_20%] items-center p-2 text-[8px] uppercase tracking-wide text-white/70 sm:text-sm">
      <div></div>
      <div className="text-left">{t('leaderboard.player')}</div>
      <div className="text-left">{t('leaderboard.nft')}</div>
      <div className="text-left">{t('leaderboard.games')}</div>
      <div className="text-left">{t('leaderboard.winPercent')}</div>
      <div className="text-left">{t('leaderboard.elo')}</div>
    </div>
  );
};
